/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../clients/api-v2-client";
import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/api-v2-client";
import type { WebAppCreateMediaExportJobsMutationRequest, WebAppCreateMediaExportJobsMutationResponse, WebAppCreateMediaExportJobs401, WebAppCreateMediaExportJobs403 } from "../models/WebAppCreateMediaExportJobs";

export function getWebAppCreateMediaExportJobsUrl() {
  const res = { method: 'POST', url: `/web-app/v1/export-jobs` as const }
  return res
}

/**
 * @description Adds an export media job for the current user. Returns the job (id, status, progress, etc.).
 * @summary Enqueue export job
 * {@link /web-app/v1/export-jobs}
 */
export async function webAppCreateMediaExportJobs(data: WebAppCreateMediaExportJobsMutationRequest, config: Partial<RequestConfig<WebAppCreateMediaExportJobsMutationRequest>> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<WebAppCreateMediaExportJobsMutationResponse, ResponseErrorConfig<WebAppCreateMediaExportJobs401 | WebAppCreateMediaExportJobs403>, WebAppCreateMediaExportJobsMutationRequest>({ method : "POST", url : getWebAppCreateMediaExportJobsUrl().url.toString(), data : requestData, ... requestConfig })
  return res.data
}